import type { SelectTagRendererProps } from '@tractian/ui'
import type { MouseEvent } from 'react'

/** Root class for tractian `Select` inside an ag-grid inline cell editor (v1 parity). */
export const INLINE_CELL_SELECT_ROOT_CLASS =
  'inline-cell-select flex size-full min-h-0 min-w-0 select-none items-center bg-white'

/**
 * Trigger/value class — strips FormFieldFrame border so the cell edge reads as
 * the control (matches v1 `AssetSingleSelectEditor` `bordered={false}`).
 */
export const INLINE_CELL_SELECT_VALUE_CLASS =
  'inline-cell-select-value h-full min-h-0 rounded-none border-0 px-0 shadow-none hover:border-0 hover:shadow-none focus-within:border-0 focus-within:shadow-none'

/**
 * Renders the selected option label as-is. Skips Select's default `TagSingle`
 * wrapper so badges and rich labels keep their view-mode layout while open.
 */
export function inlineCellSelectRenderTag({ option }: SelectTagRendererProps) {
  return option.label
}

/** Same root marker for `TreeSelect` inline location editors. */
export const INLINE_CELL_TREE_SELECT_ROOT_CLASS =
  'inline-cell-select inline-cell-tree-select flex size-full min-h-0 min-w-0 select-none items-center bg-white'

/**
 * Prevents ag-grid `stopEditingWhenCellsLoseFocus` from cancelling the edit when
 * the user clicks a portaled dropdown option.
 */
export function preventCellBlurOnPointerDown(event: MouseEvent) {
  event.preventDefault()
}
